<!-- 查看核查调拨关联的箱子标签 -->
<template>
    <div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">箱子码</div>
                <div class="search-item">
                    <el-input size="small" v-model.trim="searchData.BoxCode" placeholder="箱子码"></el-input>
                </div>
                <!-- <div class="search-name">汽配编码</div>
                <div class="search-item">
                    <el-input size="small" v-model.trim="searchData.APCode" placeholder="汽配编码"></el-input>
                </div> -->
                <div class="search-name">箱子名称</div>
                <div class="search-item">
                    <el-input size="small" v-model.trim="searchData.BoxName" placeholder="箱子名称"></el-input>
                </div>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                v-loading="loading"
                :data="tableData"
                border
                ref="multipleTable"
                max-height="470px"
                style="width: 100%; margin-bottom: 10px"
            >
                <el-table-column width="180px" prop="Code" label="箱子码" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Name" label="箱子名称" show-overflow-tooltip></el-table-column>
                <el-table-column width="80px" prop="GoodsCount" label="货物数量" show-overflow-tooltip></el-table-column>
                <el-table-column width="120px" prop="StorageName" label="存放仓库" show-overflow-tooltip></el-table-column>
                <el-table-column width="120px" prop="SpaceName" label="存放仓位" show-overflow-tooltip></el-table-column>
                <el-table-column width="100" show-overflow-tooltip label="箱子状态">
                    <template slot-scope="scope">{{ scope.row.State | stateHandle }}</template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button type="text" size="mini" @click="showLabelDetails(scope.row)">查看标签</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- <div class="dialog-pagination-ctn">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="searchData.Page" :page-sizes="[10, 20, 30, 40, 50]" :page-size="searchData.Limit"
                layout="total, sizes, prev, pager, next, jumper" :total="tableDataLength"></el-pagination>
        </div> -->

        <el-dialog :close-on-click-modal="false" title="查看标签" :visible.sync="showLabelsDialog" width="1200px" append-to-body>
            <div class="dialog-content" v-if="showLabelsDialog">
                <checkTranBoxLabels @closeDialog="closeLabelsDialog" :BoxId="toId"></checkTranBoxLabels>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import checkTranBoxLabels from '@/components/business/goods/checkTranBoxLabels.vue';
export default {
    name: '',
    props: { OrderId: String },
    components: { checkTranBoxLabels },
    data() {
        return {
            loading: false,
            searchData: {
                OrderId: this.OrderId,
                BoxCode: '',
                APCode: '',
                BoxName: '',
                Page: 1,
                Limit: 10
            },
            tableDataLength: 0,
            tableData: [],
            showLabelsDialog:false,
            toId:""
        };
    },
    filters: {
        stateHandle(value) {
            if (value == 0) {
                return '正常';
            } else if (value == 2) {
                return '已销毁';
            } else if (value == 1) {
                return '已离仓';
            }
        }
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        resetSearch() {
            this.searchData.BoxCode = '';
            this.searchData.APCode = '';
            this.searchData.BoxName = '';
            this.searchData.Page = 1;
            this.searchData.Limit = 10;
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoodsLabels/GetTranOrderBoxes',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.Limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        },
               //关闭订单弹出层
         closeLabelsDialog() {
            this.toId = '';
            if(this.showLabelsDialog) this.showLabelsDialog = false;
        },
        showLabelDetails(row) {
            if (row) {
                this.toId = row.BoxId;
                this.showLabelsDialog = true;
            } else {
                this.$util.warningMsg('请选择箱子进行查看');
                return;
            }
        }, 
    }
};
</script>
<style lang="less" scoped>
.search-ctn-left {
    margin-bottom: 10px;

    .search-name {
        margin-bottom: 0;
    }
}
</style>
